module.exports = "https://la-static.vkplay.ru/promo/universal/img/card1_new.f8f92f03.jpg";